import { AddressTypeExtension } from "pbHelpers/AddressType";
import { quack } from "protobuf-ts/quack";

export const Incremental: AddressTypeExtension = {
  addressType: quack.AddressType.ADDRESS_TYPE_INCREMENTAL,
  friendlyName: "Incremental",
  humanReadableAddress: function(componentType: quack.ComponentType, address: number): string {
    return address.toString();
  },
  singular: false
};
